import API from "@/api";
import user from "@/store/modules/user";

export default {
  namespaced: true,

  state: {},

  actions: {
    async submitTermsOfUseResponse({}, payload) {
      const data = {
        data: {
          type: "accounts_terms_of_uses",
          attributes: { accept: payload.accepted },
          relationships: {
            account: {
              data: {
                type: "accounts",
                id: user.state.user.id
              }
            },
            terms_of_use: {
              data: {
                type: "terms_of_uses",
                id: payload.termsOfUseId
              }
            }
          }
        }
      };

      await API.AccountTermsOfUse.response(data);
    },

    async getTermsOfUse() {
      return await API.AccountTermsOfUse.getTermsOfUse();
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/accountTermsOfUse.js